module.exports = __webpack_public_path__ + "a63144b5dd22cd00e74529408b1d70a6.svg";